import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomLoader from '../common/CustomLoader';
import CustomSelect from '../home/collections/CustomSelect';
import { dropdownsForSource } from '../../common/utils/data_source-util';
import { getFieldDataTypeValue, convertFields } from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class XataTableUpdate extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    externalDatabase: '',
    fieldDatatypes: [],
  };
  async componentDidMount() {
    const { actions, match } = this.props;
    const { dbUuid, projectId, version } = match.params;
    await actions.loadExternalDatabaseForXata({ projectId, version, dbUuid });
    this.setState({ externalDatabase: this.props.dataConnector.externalDatabaseXata });
  }
  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };
  handleSave = async () => {
    const { fieldDatatypes, externalDatabase } = this.state;
    const { actions, match, history } = this.props;
    const { dbUuid, projectId, version, tableName } = match.params;
    const { completeData, setting } = externalDatabase;
    const { tables, database } = completeData;
    const tableData = tables
      ? tables.find((obj) => obj.hasOwnProperty('name') && obj.name === tableName)
      : null;
    const fieldData = tableData.fields;
    const result = {};
    Object.keys(fieldData).map((fieldName, index) => {
      result[fieldName] = fieldDatatypes[fieldName]
        ? fieldDatatypes[fieldName].value
        : fieldData[fieldName];
    });
    const newResult = convertFields(result);
    const dataForSave = {
      version,
      collectionTitle: tableName,
      willPersist: false,
      fields: newResult,
      projectId,
      database: database,
      setting: setting,
      externalDatabaseId: dbUuid,
      branch: tableData.branch ? tableData.branch : '',
    };
    await actions.updateCollectionWithXata(dataForSave);
    history.push(`/data-connector/${version}/v/${projectId}/xata-edit/${dbUuid}`);
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const { externalDatabase } = this.state;
    const { dataConnector, match } = this.props;
    const { updateCollectionWithXataPending, loadExternalDatabaseForXataPending } = dataConnector;
    if (loadExternalDatabaseForXataPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader
              loading={loadExternalDatabaseForXataPending}
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }
    const { tableName } = match.params;
    const completeData = externalDatabase ? externalDatabase.completeData : null;
    const tables = completeData ? completeData.tables : null;
    const tableData = tables
      ? tables.find((obj) => obj.hasOwnProperty('name') && obj.name === tableName)
      : null;
    const fieldData = tableData ? tableData.fields : null;

    return fieldData ? (
      <CommonPageComponent>
        <ParentContentCard title={'Update Collection  via Xata'} icon={'collection'}>
          <Formik initialValues={{ collectionTitle: tableData.name }}>
            {({ values, handleChange, setFieldValue }) => (
              <Form className="ml-5">
                <div className="col-md-11 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Xata collection name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={tableData.name}
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Title"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Enter name for the collection name if  you want to change'}
                      value={tableData.name}
                    >
                      <Field
                        type="text"
                        name="collectionTitle"
                        className="form-control form-control-sm"
                        placeholder="Collection Title"
                      />
                      <ErrorMessage name="collectionTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  <div className="mt-2">
                    <h5>
                      <b>Field Type Mapping</b>
                    </h5>
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      overflow: 'visible',
                      maxHeight: 'fit-content',
                      marginBottom: '10px',
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: '50%' }}>Fields</th>
                          <th style={{ width: '50%' }}>Types</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(fieldData).map((fieldName, index) => (
                          <tr key={index}>
                            <td style={{ width: '50%' }}>{fieldName}</td>
                            <td style={{ width: '50%' }}>
                              <CustomSelect
                                name={fieldName}
                                isMulti={false}
                                onChange={setFieldValue}
                                onChangeValue={this.handleFieldChange}
                                options={dropdownsForSource}
                                value={getFieldDataTypeValue(
                                  fieldName,
                                  fieldData,
                                  this.state.fieldDatatypes,
                                )}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex justify-content-between">
                    {/* <button
                          className="btn btn-outline-secondary btn-md"
                          title="Skip"
                          type="button"
                          onClick={this.handleCollection}
                        >
                          <i className="wb webconnect-times"></i> Skip & Continue
                        </button> */}
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md"
                      title="Update Collection"
                      onClick={this.handleSave}
                      disabled={updateCollectionWithXataPending}
                    >
                      <i className="wb webconnect-save-regular"></i> Update Collection
                      <CustomLoader loading={updateCollectionWithXataPending} />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XataTableUpdate);
